<h1>{{ 'core.course.tour_navigation_course_index_student_title' | translate }}</h1>
<p>{{ 'core.course.tour_navigation_course_index_student_content' | translate }}</p>
<ion-button (click)="dismiss()" expand="block">
    {{ 'core.endonesteptour' | translate }}
</ion-button>
